// selectionStore.js
let storedButtonWrapperSelection = null

export const selectionStore = {
  // Store the selection
  setButtonWrapperSelection(selection) {
    storedButtonWrapperSelection = selection
  },

  // Get the stored selection
  getButtonWrapperSelection() {
    return storedButtonWrapperSelection
  },

  // Clear the stored selection
  clearButtonWrapperSelection() {
    storedButtonWrapperSelection = null
  },

  // Helper to check if there's a stored selection
  hasStoredSelection() {
    return storedButtonWrapperSelection !== null
  },
}

// Helper function to get button wrapper element from selection
export const getButtonWrapperFromSelection = selection => {
  const selectedElement = selection.getSelectedElement()

  // Check if selected element is a button-wrapper and not a drop-area-wide
  if (
    selectedElement &&
    selectedElement.hasClass('button-wrapper') &&
    !selectedElement.hasClass('drop-area-wide')
  ) {
    return selectedElement
  }

  // If no direct selection, find the closest ancestor that's a button-wrapper
  let viewElement = selection.editableElement?.findAncestor(element => {
    return (
      element.hasClass &&
      element.hasClass('button-wrapper') &&
      !element.hasClass('drop-area-wide')
    )
  })

  return viewElement || null
}
